import React, {useEffect, useState} from 'react';
import './StaffTabWorkplace.css';
import UniversalTable from '../UniversalTable/UniversalTable';
import {
  dismissalUserFromWorkplace,
  removeUserFromWorkplace,
} from '../../api/staffApi';
import {formatDate} from '../../utils/formatDate';

import ButtonRolesAction from '../ButtonRolesAction/ButtonRolesAction';

const StaffTabWorkplace = ({
  dataList,
  selectedItems,
  selectedItemId,
  onSelectItem,
  targetWorkplace,
  handleInviteSubmit,
  handleOpenInviteMolal,
  expandedRow,
}) => {
  const [data, setData] = useState(dataList || []);

  const columns = [
    {key: 'number', title: '№'},
    {key: 'last_name', title: 'Сотрудник'},
    {key: 'login', title: 'Логин'},

    {key: 'invited_at', title: 'Дата приема'},
    {key: 'deleted_at', title: 'Дата увольнения'},
    {
      key: 'status',
      title: 'Статус',
      type: 'status',
      deleted: 'Уволен',
      awaiting: 'Ожидает подтверждения',
      button: {
        title: 'Отменить приглашение',
        onClick: (item) => handleCancelInvitation(item),
      },
      buttonInvite: {
        title: 'Пригласить',
        onClick: (item) => {
          handleInviteSubmit(item.login, item.workplace_id);
        },
      },
      options: [
        {value: 'active', label: 'Активен'},
        {value: 'deleted', label: 'Уволен'},
      ],
      onChange: (options, row) => {
        if (options.value === 'deleted') {
          handleDismissEmployee(row);
        }
      },
    },
  ];

  useEffect(() => {
    setData(dataList);
  }, [dataList]);

  const handleCancelInvitation = (item) => {
    removeUserFromWorkplace({
      users: [item.user_id],
      organisation_id: selectedItemId,
    })
      .then(() => {
        setData(
          (prevData) =>
            prevData
              .map((user) => {
                if (user.user_id === item.user_id) {
                  // Если сотрудник уже работал, меняем статус
                  if (user.deleted_at) {
                    return {
                      ...user,
                      status: 'deleted',
                    };
                  }
                  return null; // Помечаем для удаления
                }
                return user;
              })
              .filter(Boolean) // Убираем null (удаляем сотрудников без invited_at)
        );
      })
      .catch((err) => console.error('Ошибка при удалении пользователя:', err));
  };

  const handleDismissEmployee = (row) => {
    dismissalUserFromWorkplace({
      ids: [row.id],
      organisation_id: selectedItemId,
    })
      .then((res) => {
        // Обновляем локальное состояние, не вызывая обновление всей вкладки
        console.log(res);

        setData((prevData) => {
          console.log(prevData);
          return prevData.map((user) =>
            user.id === row.id
              ? {
                  ...user,
                  status: 'deleted',
                  deleted_at: formatDate(res?.data?.deleted_at),
                }
              : user
          );
        });
      })
      .catch((err) => console.error('Ошибка при удалении пользователя:', err));
  };

  return (
    <div className='staff-tab-workplace'>
      <div className='staff-tab-workplace__header'>
        <h3 className='staff-tab-workplace__title'>Сотрудники</h3>
      </div>
      {data?.length > 0 ? (
        <UniversalTable
          data={data || []}
          columns={columns}
          handleContextMenu={() => {}}
          selectedItems={selectedItems}
          onRowClick={() => {}}
          onSelectItem={onSelectItem}
          expandedRow={null}
          showCheckboxes={false}
        />
      ) : (
        <p className='no-data-message'>Нет данных для отображения</p>
      )}

      <div className='workplaces-tab__wrapper-btn'>
        <ButtonRolesAction
          onClick={() => {
            handleOpenInviteMolal({id: expandedRow});
          }}
          className={'ButtonRolesAction_add'}
        >
          ПРИГЛАСИТЬ
        </ButtonRolesAction>
      </div>
    </div>
  );
};

export default StaffTabWorkplace;
